/* @flow */

import i18n from '../../helpers/i18n'
import type { TranslationType } from '../../helpers/i18n'
import type { PathType } from '../../data_handler'

type OptionsType = {
  labelClassName?: string
}

type OptionsOutputType = {
  ...OptionsType,
  value: string | number | boolean,
  label: TranslationType,
  info?: string
}
type OptionsOutputArrayType = Array<OptionsOutputType>

const createOptions = (
  prefix: Array<string>,
  arr: Array<string>,
  globalOptions?: OptionsType = {},
  options: Array<OptionsType> = []
): OptionsOutputArrayType => {
  prefix = Array.isArray(prefix) ? prefix : [prefix]
  return arr.map((entry, i) => {
    const path: PathType = (prefix.concat(String(entry)): any)
    const output = {
      ...globalOptions,
      ...(options && options[i] ? options[i] : {}),
      label: i18n.trans(path),
      value: entry
    }
    return output
  })
}

export { createOptions }
